/**
 * Font tokens. `fontFamilies` is the brand type identity shared across products;
 * `mobileFontFaces` are the weight-specific font-asset names React Native loads
 * via expo-font (web builds CSS font stacks from the families instead).
 */
export const fontFamilies = {
  /** Headlines / UI */
  display: 'Manrope',
  /** Body / labels */
  body: 'Plus Jakarta Sans',
} as const;

export const mobileFontFaces = {
  manropeBold: 'Manrope-Bold',
  manropeSemiBold: 'Manrope-SemiBold',
  jakartaRegular: 'PlusJakartaSans-Regular',
  jakartaMedium: 'PlusJakartaSans-Medium',
  jakartaSemiBold: 'PlusJakartaSans-SemiBold',
} as const;

export type FontFamilies = typeof fontFamilies;
export type MobileFontFaces = typeof mobileFontFaces;
